export class Validations {
  static isEmail(value) {
    return value && /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value);
  }
  static customPassword(value) {
    return (
      value &&
      value.length > 5 &&
      value.length < 21 &&
      /[a-zA-Z0-9]/.test(value) &&
      !/[-!$%^&@#¨\\*()_+|~=`{}[\]:";'<>?,./]+/.test(value)
    );
  }
  static notNumbers(value) {
    return value && !/[0-9]/.test(value);
  }
  static notSymbol(value) {
    return value && !/[-!$%^&@#¨\\*()_+|~=`{}[\]:";'<>?,./]+/.test(value);
  }
  static isName(value) {
    return (
      value &&
      /[a-zA-Zà-úÀ-Ú]/.test(value) &&
      this.notNumbers(value) &&
      this.notSymbol(value)
    );
  }
}
